import { render, staticRenderFns } from "./BaseHistogramSelections.vue?vue&type=template&id=37fab071&"
import script from "./BaseHistogramSelections.vue?vue&type=script&lang=js&"
export * from "./BaseHistogramSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports